import styled from "styled-components"

import { NFontWeight, NSubtitleS } from "@assets/styles/newTypographyStyles"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 40px;
  row-gap: 10px;
  border-bottom: 1px solid var(--gray3);
  background-color: var(--white);
`

export const Navigation = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CountText = styled(NSubtitleS)`
  font-weight: ${NFontWeight.semiBold};
`

export const Subtitle = styled.span`
  font-size: 14px;
  color: var(--darkGray2);
  font-weight: 500;
  margin-top: 6px;
  line-height: 20px;
`
